<template>
  <div>
    <!-- navigation -->
    <v-app-bar app tile class="white" style="height: auto" elevate-on-scroll>
      <v-toolbar-title>
        <Logo />
      </v-toolbar-title>
      <v-spacer />

      <div class="d-none d-md-block">
        <v-btn
          v-for="(item, k) in menu"
          :key="k"
          :text="!item.class"
          :class="`${item.class || ''} ${k !== menu.length - 1 && 'mr-2'} ${
            btnProps.class
          }`"
          :to="item.routeName && { name: item.routeName }"
          v-bind="btnProps"
          >{{ item.text }}</v-btn
        >
      </div>
      <v-app-bar-nav-icon
        class="ml-2 d-block d-md-none"
        @click="drawer = true"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer temporary v-model="drawer" right app>
      <v-list nav dense class="text-uppercase">
        <v-list-item>
          <v-spacer></v-spacer>
          <v-btn fab x-small outlined @click="drawer = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item>

        <v-list-item
          v-for="(item, k) in menu"
          :key="k"
          router
          link
          :to="item.routeName && { name: item.routeName }"
          >{{ item.text }}</v-list-item
        >
      </v-list>

      <template v-slot:append>
        <PageFooter :side="true" />
      </template>
    </v-navigation-drawer>

    <!-- page content -->
    <Banner />

    <PageBreak
      :componentStyle="`background-color: var(--v-primary-base); color: white;`"
    >
      <template v-slot:header
        >Your poll. <u style="font: inherit">Any</u> device.
        <u style="font: inherit">Any</u> location.</template
      >
      <!-- <template v-slot:body>Lorem, ipsum dolor.</template> -->
    </PageBreak>

    <GridLayout :componentStyle="`margin: 100px 0;`" />

    <Stripe
      :componentStyle="`background-color: var(--v-primary-base); color: white; margin: 100px 0 150px;`"
    >
      <ColumnLayout :imagePath="`'@/assets/images/note-list.svg'`">
        <template v-slot:c1Header>Creating a poll</template>

        <template v-slot:c1Body>
          <v-row>
            <v-col cols="12">
              It's easy to build and customize your poll.
            </v-col>
          </v-row>

          <v-row class="mt-8">
            <v-col v-for="(step, i) in steps" :key="i" cols="12" md="6">
              <v-icon large class="white--text mb-2">{{ step.icon }}</v-icon>
              <h3>{{ i + 1 }}. {{ step.heading }}</h3>
              <p>
                {{ step.text }}
              </p>
            </v-col>
            <v-col>
              <v-btn class="my-5" depressed :to="{ name: 'Auth' }"
                >create your first poll</v-btn
              >
            </v-col>
          </v-row>
        </template>
      </ColumnLayout>
    </Stripe>

    <Comments />

    <Slope
      :componentStyle="`margin: 80px 0;`"
      bgColor="var(--v-primary-base)"
      textColor="white"
    >
      <v-container>
        <v-row
          style="color: white; height: 100%; padding-top: 8vw"
          justify="center"
          align="center"
        >
          <v-col cols="12" md="5">
            <h1 style="line-height: 100%" class="mb-6">Ready to help.</h1>
            The complexity and vote deadlines can be stressful for certain
            organizations. Thousands of organizations have dealt with millions
            of votes. We know what you're up against, and we put your needs
            first. We can handle it for you, whether you want to run it yourself
            with little training or you want us to take the vote off your hands.
            We understand.
          </v-col>

          <v-col cols="12" md="5" class="d-none d-md-block ml-auto">
            <v-row align="center" justify="center" style="height: 100%">
              <object
                width="100%"
                :data="require('@/assets/images/support.svg')"
                type="image/svg+xml"
              ></object>
            </v-row>
          </v-col>
        </v-row>

        <v-row style="color: white">
          <v-col cols="12" md="3" sm="6" v-for="(item, i) in services" :key="i">
            <v-icon large class="white--text">{{ item.icon }}</v-icon>
            <h3 class="mt-3">{{ item.heading }}</h3>
            <p class="mt-1">
              {{ item.text }}
            </p>
          </v-col>
        </v-row>
      </v-container>
    </Slope>

    <PageBreak
      :componentStyle="`background-color: white; color: var(--v-primary-base); margin: 100px 0 20px;`"
    >
      <template v-slot:header
        >Make your decision-making process modern, secure, and
        effective.</template
      >
      <template v-slot:body>
        <p>
          Upgrade from manually counting ballots to an voting system without
          sacrificing the integrity of your vote
        </p>
        <v-btn class="primary mt-4" large depressed :to="{ name: 'Auth' }"
          >Start now</v-btn
        >
      </template>
    </PageBreak>

    <PageFooter />
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import { btnProps } from "@/helpers";
import Banner from "../components/Banner.vue";
import PageFooter from "../components/PageFooter.vue";
import {
  PageBreak,
  GridLayout,
  Stripe,
  ColumnLayout,
  Comments,
  Slope,
} from "@/templates";

export default {
  components: {
    Logo,
    Banner,
    PageBreak,
    GridLayout,
    Stripe,
    Comments,
    ColumnLayout,
    Slope,
    PageFooter,
  },

  data: () => ({
    btnProps,
    drawer: false,

    menu: [
      { text: "Pricing" },
      { text: "Support" },
      { text: "Vote", routeName: "LogIn" },
      { text: "Sign In", routeName: "Auth" },
      { text: "Request Demo", class: "primary" },
    ],

    steps: [
      {
        icon: "mdi-chart-histogram",
        heading: "Create the Poll",
        text: "Add basic information of poll which include: title, start and end times, publishing medium, and description.",
      },
      {
        icon: "mdi-order-bool-descending-variant",
        heading: "Add Sections",
        text: "Add sections to your poll and add options to your sections. Add a photo to your options.",
      },
      {
        icon: "mdi-account-group",
        heading: "Add Voters",
        text: "You control who is eligible to vote in your poll. Add voters one-by-one, or import them from a spreadsheet.",
      },
      {
        icon: "mdi-mail",
        heading: "Publish",
        text: "A poll is not complete if there are no voters involved. Hence, you get to publish your poll to the voters.",
      },
    ],

    services: [
      {
        icon: "mdi-cog",
        heading: "Easy setup",
        text: "We make it super easy for you to set up a poll and for your voters to cast their votes.",
      },
      {
        icon: "mdi-help-rhombus",
        heading: "Dedicated assistance",
        text: "We walk you through the setup process, answer your questions and verify your settings.",
      },
      {
        icon: "mdi-lock-check",
        heading: "Voter management",
        text: "We ensure that no one - not even yourself - can tamper with the results. ",
      },
      {
        icon: "mdi-tag-arrow-down",
        heading: "Relatively Low Prices ",
        text: "Our prices are low and easy to understand, with no commitments or hidden fees.",
      },
    ],
  }),
};
</script>
